export default "__VITE_ASSET__DxuhZydx__"